import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

/**
 * An organization's logo on its public careers pages.
 *
 * Draws nothing when there is no logo, or when the picture fails to load, rather
 * than a broken-image icon above a job. Kept to a fixed height so a tall logo
 * cannot push the job below the fold on a phone, and its width is capped so a
 * wide one cannot run off it.
 */
const OrganizationLogo = ({ url, name, sx }) => {
  const [failed, setFailed] = useState(false);

  // A new address is a new logo, and gets a fresh chance to load.
  useEffect(() => {
    setFailed(false);
  }, [url]);

  if (!url || failed) return null;

  return (
    <Box
      component="img"
      src={url}
      alt={name ? `${name} logo` : 'Company logo'}
      onError={() => setFailed(true)}
      sx={{
        display: 'block',
        maxHeight: { xs: 56, sm: 72 },
        maxWidth: { xs: '70%', sm: 280 },
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        ...sx,
      }}
    />
  );
};

export default OrganizationLogo;
